import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { Slot } from '@radix-ui/react-slot';
import { cn } from '@anytag/shared-utils';

const TooltipProvider = ({ delayDuration = 0, ...props }: React.ComponentProps<typeof TooltipPrimitive.Provider>) => (
  <TooltipPrimitive.Provider data-slot="tooltip-provider" delayDuration={delayDuration} {...props} />
);

const Tooltip = ({ ...props }: React.ComponentProps<typeof TooltipPrimitive.Root>) => (
  <TooltipProvider>
    <TooltipPrimitive.Root data-slot="tooltip" {...props} />
  </TooltipProvider>
);

const TooltipTrigger = ({ ...props }: React.ComponentProps<typeof TooltipPrimitive.Trigger>) => (
  <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} />
);

export interface TooltipContentProps extends React.ComponentProps<typeof TooltipPrimitive.Content> {
  withArrow?: boolean;
  withinPortal?: boolean;
}
const TooltipContent = ({
  className,
  sideOffset = 0,
  withArrow = true,
  children,
  withinPortal,
  ...props
}: TooltipContentProps) => {
  const Wrapper = withinPortal ? TooltipPrimitive.Portal : Slot;

  return (
    <Wrapper>
      <TooltipPrimitive.Content
        data-slot="tooltip-content"
        sideOffset={sideOffset}
        className={cn(
          'z-50 w-fit origin-(--radix-tooltip-content-transform-origin) animate-in rounded-md bg-black-90 px-3 py-1.5 text-[11px] font-normal text-balance text-white fade-in-0 zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95',
          className
        )}
        {...props}
      >
        {children}
        {withArrow && (
          <TooltipPrimitive.Arrow className="tooltip-arrow z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px] bg-black-90 fill-black-90" />
        )}
      </TooltipPrimitive.Content>
    </Wrapper>
  );
};

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
